'use client'

import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { Grid, Button, Divider } from '@mui/material'

// Types
import type { LangButtonProps } from '@/types/components/atoms/buttons/lang'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const LangButtonAtom = (props: LangButtonProps) => {
	// Props
	const { lng } = props

	// Variables
	const { t } = useTranslation()
	const pathname = usePathname()

	return (
		<Grid container alignItems="center" spacing={1}>
			<Grid display="inline-flex" size="auto">
				<Link href={`/en${pathname.replace(`/${lng}`, '')}`}>
					<Button
						size="medium"
						sx={{
							minWidth: 'auto',
							px: 1,
							textTransform: 'inherit',
							color: 'common.black',
							bgcolor: 'transparent'
						}}
					>
						{t(`common:title.en`)}
					</Button>
				</Link>
			</Grid>

			<Divider orientation="vertical" flexItem sx={{ my: 1 }} />

			<Grid display="inline-flex" size="auto">
				<Button
					size="medium"
					disabled
					sx={{
						minWidth: 'auto',
						px: 1,
						textTransform: 'inherit',
						color: 'common.black',
						bgcolor: 'transparent',
						'&:disabled': {
							color: 'grey.500',
							bgcolor: 'transparent'
						}
					}}
				>
					{t(`common:title.tl`)}
				</Button>
			</Grid>
		</Grid>
	)
}

export default LangButtonAtom
